/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_admin_tab_bugs = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bug reports`)
};

const es_admin_tab_bugs = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informes de errores`)
};

const de_admin_tab_bugs = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlerberichte`)
};

const nl_admin_tab_bugs = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bugmeldingen`)
};

const fr_admin_tab_bugs = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapports de bugs`)
};

const it_admin_tab_bugs = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segnalazioni di bug`)
};

const pt_br2_admin_tab_bugs = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relatos de bugs`)
};

const pt_admin_tab_bugs = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relatórios de erros`)
};

const ja_admin_tab_bugs = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バグ報告`)
};

const zh_admin_tab_bugs = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bug 反馈`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const admin_tab_bugs = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.admin_tab_bugs(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("admin_tab_bugs", locale)
	if (locale === "en") return en_admin_tab_bugs(inputs)
	if (locale === "es") return es_admin_tab_bugs(inputs)
	if (locale === "de") return de_admin_tab_bugs(inputs)
	if (locale === "nl") return nl_admin_tab_bugs(inputs)
	if (locale === "fr") return fr_admin_tab_bugs(inputs)
	if (locale === "it") return it_admin_tab_bugs(inputs)
	if (locale === "pt-BR") return pt_br2_admin_tab_bugs(inputs)
	if (locale === "pt") return pt_admin_tab_bugs(inputs)
	if (locale === "ja") return ja_admin_tab_bugs(inputs)
	return zh_admin_tab_bugs(inputs)
};